module.exports = __webpack_public_path__ + "static/media/florida.dfd5ff16.svg";